'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _Radio = require('./Radio/Radio');

var _RadioGroupStyled = require('./styles/RadioGroupStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * Default value of the RadioGroup
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Value of the RadioGroup
   */
  value: _propTypes2.default.any,
  /**
   * Options of the RadioGroup
   */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.any.isRequired,
    text: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
  })),
  /**
   * Specify function to call on RadioGroup value change
   */
  onChange: _propTypes2.default.func
};
var defaultProps = {
  defaultValue: void 0,
  value: void 0,
  options: [],
  onChange: _reactackleCore.noop
};

var RadioGroup = function (_Component) {
  _inherits(RadioGroup, _Component);

  function RadioGroup(props) {
    _classCallCheck(this, RadioGroup);

    var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

    _this.state = {
      value: (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value
    };

    _this._handleChange = _this._handleChange.bind(_this);
    return _this;
  }

  _createClass(RadioGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value && (0, _reactackleCore.isUndef)(nextProps.value)) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: '_getCurrentValue',
    value: function _getCurrentValue() {
      return (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(_ref) {
      var value = _ref.value;

      var currentValue = this._getCurrentValue();

      if (currentValue === value) return;

      if ((0, _reactackleCore.isUndef)(this.props.value)) {
        this.setState({
          value: value
        });
      }

      this.props.onChange({
        value: value
      });
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var _this2 = this;

      var value = this._getCurrentValue();

      return this.props.options.map(function (item, k) {
        return _react2.default.createElement(_Radio.Radio, _extends({}, item, {
          key: (0, _reactackleCore.getKey)(item, k),
          index: k,
          onChange: _this2._handleChange,
          checked: value === item.value
        }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this._renderOptions();

      return _react2.default.createElement(
        _RadioGroupStyled.RadioGroupStyled,
        null,
        options
      );
    }
  }]);

  return RadioGroup;
}(_react.Component);

exports.default = RadioGroup;


RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
RadioGroup.displayName = 'RadioGroup';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-radio-group/dist/RadioGroup.js
// module id = 778
// module chunks = 0